import $ from "jquery";
import { useEffect, useState } from "react";

function Logo({ isCollapsed, setIsCollapsed }) {
  const [currentTheme, setCurrentTheme] = useState("template2");
  
  // Effect to detect theme changes
  useEffect(() => {
    // Get theme from sessionStorage or use default
    const theme = sessionStorage.getItem("selectedTheme") || "template2";
    setCurrentTheme(theme);
    
    // Optional: Listen for theme changes if needed elsewhere in the app
    const handleThemeChange = () => {
      const newTheme = sessionStorage.getItem("selectedTheme") || "template2";
      setCurrentTheme(newTheme);
    };
    
    // You could use a custom event or interval to check for theme changes
    // For simplicity, we'll check every second (adjust as needed)
    const interval = setInterval(() => {
      const newTheme = sessionStorage.getItem("selectedTheme") || "template2";
      if (newTheme !== currentTheme) {
        setCurrentTheme(newTheme);
      }
    }, 1000);
    
    return () => clearInterval(interval);
  }, [currentTheme]);
    
  return (
    <div className="d-flex align-item-center h-54px">
      <i 
        onClick={() => setIsCollapsed(!isCollapsed)} 
        className="fas fa-bars hamburger text-white font-size-18 ps-3"
      ></i>
      <div className="navbar-brand-box ps-2">
        <a href="#" className="logo logo-light">
          <span className="logo-sm">
            <img
              src="/assets/images/favicon.png"
              alt="logo-sm-light"
              height="25"
              className="position-right-5px"
            />
          </span>
          <span className="logo-lg">
            <img
              className="pt-0 pb-2 ps-0"
               src={
    currentTheme === "template1" || currentTheme === "template4"
      ? "/assets/images/dark-logo.png"
      : "/assets/images/DBShift-Logo.svg"
  }
              alt="logo-light"
              height="35"
            />
          </span>
        </a>
      </div>
    </div>
  );
}

export default Logo;